import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconRefreshSvg } from "./IconRefreshSvg.mjs";
const IconRefresh = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconRefreshSvg, ...svgProps }) });
export {
  IconRefresh
};
